import { getCSRCookieData } from '../getCSRCookieData'

export const isHybridEnabledCSR = () =>
  Number(getCSRCookieData('_IL-app-hybrid')) > 0

export default isHybridEnabledCSR
